import { IInterviewDetails } from "@/types/interview.types";
import { HTTP_METHODS } from "../constants/HttpConstants";
import {
  sendRequestToInterview,
  sendRequestToInterviewWithCredential,
} from "../utils/request.utils";

export const getInterviewDetailAPI = (interviewSlug: string) =>
  sendRequestToInterviewWithCredential<IInterviewDetails>({
    method: HTTP_METHODS.GET,
    url: `/interviews/${interviewSlug}/`,
  });

export const getInterviewMetaAPI = (accessCode: string) =>
  sendRequestToInterview<IInterviewDetails>({
    method: HTTP_METHODS.GET,
    url: `/interviews/${accessCode}/meta/`,
  });

export const doScheduleCheckAPI = (slug: string, accessCode: string) =>
  sendRequestToInterviewWithCredential({
    method: HTTP_METHODS.POST,
    url: `/interviews/${slug}/schedule_check/`,
    data: { access_code: accessCode },
  });
